/**
 * Client mirror of server/api-util/emailCodeVerified.js: the 6-digit email code
 * (profile.metadata.emailCodeVerifiedEmail, server-written) counts as verified
 * when it matches the CURRENT email.
 */
const norm = e => String(e || '').trim().toLowerCase();

export const codeVerifiedFromAttrs = a =>
  !!a &&
  !!a.email &&
  !a.pendingEmail &&
  norm(a?.profile?.metadata?.emailCodeVerifiedEmail) === norm(a.email);

/** Returns the user with attributes.emailVerified=true when the code flag matches. */
export const withEmailCodeVerified = user => {
  const a = user?.attributes;
  if (!a || a.emailVerified === true || !codeVerifiedFromAttrs(a)) return user;
  return { ...user, attributes: { ...a, emailVerified: true, emailVerifiedByCode: true } };
};
